import r from "./_getNative.js";
import o from "./_root.js";
var t = r, e = o, a = t(e, "Promise"), v = a;
export {
  v as default
};
//# sourceMappingURL=_Promise.js.map
